module.exports = "<wor-navbar></wor-navbar>\n<ui-view class=\"height-100\"></ui-view>";